// import React from 'react'

// function UpdateSubcategory() {
//     return (
//         <div>
//             ssssssssssssss
//         </div>
//     )
// }

// export default UpdateSubcategory



import { API } from "../../../config/api";
import { GET, PUT } from "../../../utils/apicalls";
import { UploadOutlined } from "@mui/icons-material";

import { Button, Card, Form, Input, notification, Select, Upload } from "antd";
import AWS from "aws-sdk";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";


function UpdateSubcategory() {
    const [form] = Form.useForm();
    const [categorydata, setCategoryData] = useState<any>([]);
    const [data, setData] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [fileUrl, setFileUrl] = useState<string | null>(null);

    const navigate = useNavigate();
    const { id } = useParams();
    interface AwsData {
        accessKeyId?: string;
        secretAccessKey?: string;
        region?: string;
        [key: string]: any;
    }
    const [awsData, setawsData] = useState<AwsData>({});
    const s3 = new AWS.S3({
        accessKeyId: awsData.accessKeyId,
        secretAccessKey: awsData.secretAccessKey,
        region: awsData.region,
    });
    const handleFileChange = (info: any) => {
        if (info.file.status === "done") {
            const fileUrl = info.file.response?.location || info.file.response?.url; // AWS usually returns `location`
            if (fileUrl) {
                setFileUrl(fileUrl);
                form.setFieldsValue({ serviceCategory: fileUrl }); // Update form field value
            }
        } else if (info.file.status === "error") {
            notification.error({ message: "File upload failed!" });
        }
    };
    const fetchawsDetails = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.AWS_KEY, {}); // This should return the above JSON
            if (response && response.accessKeyId) {
                setawsData(response); // Not response.data
            } else if (response?.data?.accessKeyId) {
                setawsData(response.data); // If using Axios-style
            } else {
                console.warn("AWS credentials not found in response", response);
            }
        } catch (error) {
            console.error("Failed to fetch AWS credentials", error);
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        if (awsData.accessKeyId && awsData.secretAccessKey && awsData.region) {
            AWS.config.update({
                accessKeyId: awsData.accessKeyId,
                secretAccessKey: awsData.secretAccessKey,
                region: awsData.region,
            });
        }
    }, [awsData]);
    useEffect(() => {
        fetchawsDetails();
    }, []);
    const S3_BUCKET = awsData?.bucketName;

    const uploadProps = {
        name: "file",
        action: `https://s3.${AWS.config.region}.amazonaws.com/${S3_BUCKET}/`,
        headers: {
            "x-amz-acl": "public-read",
            "Content-Type": "multipart/form-data",
        },
        onChange: handleFileChange,
        customRequest: async (options: any) => {
            const { onSuccess, onError, file } = options;
            const params = {
                Bucket: S3_BUCKET,
                Key: `about/${file.name}`,
                Body: file,
                // ACL: "public-read",
                ContentType: file.type,
            };

            s3.upload(params, (err: any, data: any) => {
                if (err) {
                    onError(err);
                    notification.error({ message: "File upload failed!" });
                } else {
                    setFileUrl(data.Location); // Set file URL on successful upload
                    form.setFieldsValue({ serviceCategory: data.Location });
                    onSuccess(data);
                    notification.success({ message: "File uploaded successfully!" });
                }
            });
        },
    };

    const UpdateHandler = async (values: any) => {
        try {
            let obj = {
                SubcategoryTitle: values.SubcategoryTitle,
                SubcategoryImage: fileUrl, // Use uploaded file URL
                category_id: values.category_id
            };

            setIsLoading(true);
            let api = API.UPDATE_SUBCATEGORY + id;
            const postRequest: any = await PUT(api, obj);
            if (postRequest.status) {
                notification.success({ message: " updated successfully!" });
                form.resetFields();
                fetchonesubcategory();
                navigate(-1);
            } else {
                notification.error({ message: "Something went wrong" });
            }
        } catch (error) {
            console.error(error);
            notification.error({
                message: "Something went wrong! Please try again later",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const fetchonesubcategory = async () => {
        try {
            setIsLoading(true);
            let api = API.FIND_ONE_SUBCATEGORY + id;
            const response: any = await GET(api, {});
            setData(response?.data);
            form.setFieldsValue(response?.data);
            if (response?.data?.SubcategoryImage) {
                setFileUrl(response.data.SubcategoryImage);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        fetchonesubcategory();
    }, []);
    const fetchCategories = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.LISTING_GET_CATEGORY, {});
            setCategoryData(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchCategories();

    }, []);
    return (
        <div>
            <h1>Update Category Management</h1>
            <Card>
                <Form form={form} onFinish={UpdateHandler} layout="vertical">
                    <Form.Item name="category_id">
                        <Select
                            placeholder="Select category"
                            allowClear
                            style={{ width: "200px" }}
                            options={categorydata?.map((item: any) => ({
                                value: item.id,
                                label: item.categoryTitle,
                            })) || []}
                        />
                    </Form.Item>
                    <Form.Item
                        name="SubcategoryTitle"
                        label="SubcategoryTitle"
                        rules={[{ required: true }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item label="Subcategory image" name="SubcategoryImage">
                        <Upload {...uploadProps}>
                            <Button icon={<UploadOutlined />}>Upload Image</Button>
                        </Upload>
                    </Form.Item>

                    {/* Display Uploaded Image */}
                    {fileUrl && (
                        <div style={{ marginTop: 10 }}>
                            <img
                                src={fileUrl}
                                alt="Uploaded subcategory"
                                style={{ width: "20%", height: "20vh", objectFit: "cover" }}
                            />
                        </div>
                    )}

                    <Button type="primary" htmlType="submit" block>
                        Submit
                    </Button>
                </Form>
            </Card>
        </div>
    );
}

export default UpdateSubcategory;
